
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    components: {
    },
})
export default class JielongTitleCard extends Vue {
    @Prop({ type: String, default: "" }) value!: string;
    @Prop({ type: Boolean, default: false }) readonly!: boolean;
    maxLength = 50;
    errorMsg = "";
    isShake = false;

    get title (): string {
        return this.value;
    }

    set title (val: string) {
        if (this.errorMsg && val.trim()) this.errorMsg = "";
        this.$emit("input", val);
    }

    validate (): boolean {
        if (this.readonly) return true;
        if (!this.value || !this.value.trim()) {
            this.errorMsg = "请输入接龙标题";
            this.shake();
            return false;
        }
        this.errorMsg = "";
        return true;
    }

    shake (): void {
        this.isShake = true;
        window.setTimeout(() => {
            this.isShake = false;
        }, 1000);
    }
}
